// extracted by mini-css-extract-plugin
export default {"loadingblock":"_1MGQhIKd8FQMS0DV-BpOiK"};